<template>
  <div class="broadcast_head" id="broadcast_head" :style="{height:`${height}rem`}">
    <div id="logoDiv" class="font_style" style="position: relative;display: flex;align-items: center;">
      <img :src="logoPath" class="logo" style="position: absolute;top: 42%;
    left: 38%;
    transform: translate(-50%, -50%);">
      <svg-icon style="width: 100%;height: 100%;" :iconClass="header_top_left" className="stateClass"></svg-icon>
    </div>
    <div v-show="showMean" :style="{'width': (1.85)+'rem','height':'0.625rem'}" id="mean_for_width"></div>
    <div :class="has_emergency ? 'header_middle_bar_has_emergency' :'header_middle_bar_not_emergency'">
      <div class="outer" :style="{'padding-left':(outerPaddingLeft )+'px'}">
        <div class="inner" :style="{'width': '100%','height':`${height}rem`}">
          <div class="noMore">
            <draggable
            class="syllable_ul"
            element="ul"
            :list="displayMenuItem"
            touchStartThreshold="40px"
            :no-transition-on-drag="true"
            :handle="'.defaultTag'"
            @start="start"
            @end="end"
            >
              <div v-for="(item , idx) in displayMenuItem" :key="idx" @contextmenu.prevent="onContextmenu($event,1, item.to)" class="broadcast_icon defaultTag top-header"
              @click.stop.prevent="changeSel(item.change)"
                     @mouseover="changeImg('enter',item.change)" @mouseout="changeImg('out',item.change)"
                     :class="[isActive==item.change?'active':'']"  v-show="item.menu == -1 || menuArr[item.menu]">
                  <Badge class="ivu-badge-span" :count="messageCount" v-if="item.to == '/reporting_information'">
                  </Badge>
                  <Badge class="ivu-badge-span" :count="videoCount" v-else-if="item.to == '/video_surveillance'">
                  </Badge>
                  <Badge class="ivu-badge-span" :count="channelCount" v-else-if="item.to == '/chatChannel'">
                  </Badge>
                <svg-icon style="width: 100%;height: 100%;" :iconClass="isActive==item.change ? header_top_mean_b : header_top_mean" className="stateClass">
                </svg-icon>
                  <div class="icon_font top-header-menu" :title="$t(item.title)">{{$t(item.title)}}</div>
                </div>
            </draggable>

          </div>
          <!-- 更多菜单 -->
          <div class="showMore" v-show="hiddenMenuItem.length>0">
            <Dropdown trigger="click" placement="bottom-start" @on-visible-change="showDropdownMenu">

              <div class="broadcast_icon" style="width: 1.7rem;margin-left: 0.15rem" v-if="true" @click="changeSel('14')"
                   @mouseover="changeImg('enter','14')" @mouseout="changeImg('out','14')"
                   :class="[isActive==='14' || childHover ?'active':'']">
                <Badge :count="isShowBadge" class="ivu-badge-span" >
                </Badge>

                <svg-icon style="width: 100%;height: 100%;" :iconClass="header_top_mean" className="stateClass">
                </svg-icon>
                <div class="icon_font top-header-menu" >{{$t("display_more")}}</div>
              </div>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item,index) in hiddenMenuItem" :key="index"
                              :class="[isActiveInHiddenItem(item.menuId) ? 'selectedActive' : '']">
                  <!--级联管理-->
                  <router-link to="/cascade" v-if="item.type === 'cascade_manager'">
                    <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/cascade',1,$event)"
                               @end="onEnd('/cascade',1,2,$event)" :sort="false">
                      <div @contextmenu.prevent="onContextmenu($event,2, '/cascade')" class="more_content" @click="changeSelInHidden('17')" @mouseover="changeImg('enter','17')"
                           @mouseout="changeImg('out','17')" :class="[isActiveInHidden==='17'?'activeInHidden':'']">
                        <!--<img class="more_icon" :src="cascadeManager">-->
                        <div class="more_icon_desc">{{$t('cascade_manager')}}</div>
                      </div>
                    </draggable>
                  </router-link>
                  <!--通讯调度-->
                  <router-link to="/dispatch" v-if="item.type ==='dispatch'">
                    <draggable choseClass="chose" forceFallback="true" animation="1000" @start="onStart('/dispatch',1,$event)" @end="onEnd('/dispatch',1,2,$event)" :sort="false">
                      <div @contextmenu.prevent="onContextmenu($event,2,'/dispatch')" class="more_content" @click="changeSelInHidden('19')"
                           @mouseover="changeImg('enter','19')" @mouseout="changeImg('out','19')" :class="[isActiveInHidden==='19'?'activeInHidden':'']">
                        <div class="more_icon_desc">{{$t('more_menu_dispatch')}}</div>
                      </div>
                    </draggable>

                  </router-link>
                  <!--主控台-->
                  <router-link to="/control" v-show="item.type === 'control'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/control',1,$event)"
                               @end="onEnd('/control',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/control')" class="more_content" @click="changeSelInHidden('1')" @mouseover="changeImg('enter','1')"
                         @mouseout="changeImg('out','1')" :class="[isActiveInHidden==='1'?'activeInHidden':'']"
                         v-show="menuArr[8]">
                      <!--<img class="more_icon" :src="fourBlockWhiteInit">-->
                      <div class="more_icon_desc">{{$t('more_menu_control')}}</div>
                    </div>
                  </draggable>
                  </router-link>

                  <router-link to="/conference" v-if="item.type === 'conference'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/conference',1,$event)"
                               @end="onEnd('/conference',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/conference')" class="more_content" @click="changeSelInHidden('2')" @mouseover="changeImg('enter','2')"
                         @mouseout="changeImg('out','2')" :class="[isActiveInHidden==='2'?'activeInHidden':'']"
                         v-show="menuArr[7]">
                      <!--<img class="more_icon" :src="conferenceRoomInit">-->
                      <div class="more_icon_desc">{{$store.state.user.videoConf > 0 ? $t('more_menu_video_conference') : $t('more_menu_conference')}}</div>
                    </div>
                  </draggable>
                  </router-link>

                  <router-link to="/broadcast" v-if="item.type === 'broadcast'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/broadcast',1,$event)"
                               @end="onEnd('/broadcast',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/broadcast')" class="more_content" @click="changeSelInHidden('3')" @mouseover="changeImg('enter','3')"
                         @mouseout="changeImg('out','3')" :class="[isActiveInHidden==='3'?'activeInHidden':'']"
                         v-show="menuArr[5]">
                      <!--<img class="more_icon" :src="hornInit">-->
                      <div class="more_icon_desc">{{$t('more_menu_broadcast')}}</div>
                    </div>
                  </draggable>
                  </router-link>

                  <router-link to="/unattended" v-if="item.type === 'unattended'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/unattended',1,$event)"
                               @end="onEnd('/unattended',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/unattended')" class="more_content" @click="changeSelInHidden('4')" @mouseover="changeImg('enter','4')"
                         @mouseout="changeImg('out','4')" :class="[isActiveInHidden==='4'?'activeInHidden':'']">
                      <!--<img class="more_icon" :src="standGuardInit">-->
                      <div class="more_icon_desc">{{$t('more_menu_standGuard')}}</div>
                    </div>
                  </draggable>
                  </router-link>

                  <router-link to="/alarm" v-if="item.type === 'merge_alarm_plan'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/alarm',1,$event)"
                               @end="onEnd('/alarm',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/alarm')" class="more_content" @click="changeSelInHidden('5')" @mouseover="changeImg('enter','5')"
                         @mouseout="changeImg('out','5')" :class="[isActiveInHidden==='5'?'activeInHidden':'']"
                         v-show="menuArr[1]">
                      <!--<img class="more_icon" :src="warningInit">-->
                      <div class="more_icon_desc">{{$t('more_menu_warning')}}</div>
                    </div>
                  </draggable>
                  </router-link>

                  <router-link to="/monitor" v-if="item.type === 'monitor'">
                    <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/monitor',1,$event)"
                               @end="onEnd('/monitor',1,2,$event)" :sort="false">
                      <div @contextmenu.prevent="onContextmenu($event,2, '/monitor')" class="more_content"
                           @click="changeSelInHidden('6')" @mouseover="changeImg('enter','6')"
                           @mouseout="changeImg('out','6')" :class="[isActiveInHidden==='6'?'activeInHidden':'']"
                           v-show="menuArr[0]">
                        <!--<img class="more_icon" :src="videoInit">-->
                        <div class="more_icon_desc">{{$t('more_menu_video')}}</div>
                      </div>
                    </draggable>
                  </router-link>

                  <router-link to="/station" v-if="item.type === 'station'">
                    <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/station',1,$event)"
                               @end="onEnd('/station',1,2,$event)" :sort="false">
                      <div @contextmenu.prevent="onContextmenu($event,2, '/station')" class="more_content"
                           @click="changeSelInHidden('7')" @mouseover="changeImg('enter','7')"
                           @mouseout="changeImg('out','7')" :class="[isActiveInHidden==='7'?'activeInHidden':'']"
                           v-show="menuArr[2]">
                        <!--<img class="more_icon" :src="mapInit">-->
                        <div class="more_icon_desc">{{$store.state.user.mapGis ? $t('more_menu_gis_map'):$t('more_menu_map')}}</div>
                      </div>
                    </draggable>
                  </router-link>

                  <router-link to="/notice" v-if="item.type === 'notice'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/notice',1,$event)"
                               @end="onEnd('/notice',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/notice')" class="more_content" @click="changeSelInHidden('9')" @mouseover="changeImg('enter','9')"
                         @mouseout="changeImg('out','9')" :class="[isActiveInHidden==='9'?'activeInHidden':'']">
                      <!--<img class="more_icon" :src="queuingNoticeInit">-->
                      <div class="more_icon_desc">{{$t('more_menu_queuing_notice')}}</div>
                    </div>
                  </draggable>
                  </router-link>

                  <router-link to="/linkman" v-if="item.type === 'linkman'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/linkman',1,$event)"
                               @end="onEnd('/linkman',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/linkman')" class="more_content" @click="changeSelInHidden('10')" @mouseover="changeImg('enter','10')"
                         @mouseout="changeImg('out','10')" :class="[isActiveInHidden==='10'?'activeInHidden':'']">
                      <!--<img class="more_icon" :src="contactsInit">-->
                      <div class="more_icon_desc">{{$t('more_menu_contacts')}}</div>
                    </div>
                  </draggable>
                  </router-link>

                  <router-link to="/reporting_information" v-if="item.type === 'reporting_information'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/reporting_information',1,$event)"
                               @end="onEnd('/reporting_information',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/reporting_information')" class="more_content" @click="changeSelInHidden('13')" @mouseover="changeImg('enter','13')"
                         @mouseout="changeImg('out','13')" :class="[isActiveInHidden==='13'?'activeInHidden':'']">
                      <!--<Badge :count="messageCount">
                        <img class="more_icon" :src="upInfoInit">
                      </Badge>-->
                      <div class="more_icon_desc">
                        <Badge :count="messageCount">
                          {{$t('more_menu_reporting_information')}}
                        </Badge>
                       </div>
                    </div>
                  </draggable>
                  </router-link>
                  <!--自检任务-->
                  <router-link to="/self_check" v-if="item.type === 'self_check'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/self_check',1,$event)"
                               @end="onEnd('/self_check',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/self_check')" class="more_content" @click="changeSelInHidden('15')" @mouseover="changeImg('enter','15')"
                         @mouseout="changeImg('out','15')" :class="[isActiveInHidden==='15'?'activeInHidden':'']">
                      <!--<img class="more_icon" :src="selfCheckInit">-->
                      <div class="more_icon_desc">{{$t('self_check')}}</div>
                    </div>
                  </draggable>
                  </router-link>
                  <!--整点报时任务-->
                  <router-link to="/hourly_chime" v-if="item.type === 'hourly_chime'">
                  <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/hourly_chime',1,$event)"
                               @end="onEnd('/hourly_chime',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/hourly_chime')" class="more_content" @click="changeSelInHidden('16')" @mouseover="changeImg('enter','16')"
                         @mouseout="changeImg('out','16')" :class="[isActiveInHidden==='16'?'activeInHidden':'']">
                      <!--<img class="more_icon" :src="hourlyChime">-->
                      <div class="more_icon_desc">{{$t('hourly_chime')}}</div>
                    </div>
                  </draggable>
                  </router-link>
                  <!--视频监视-->
                  <router-link to="/video_surveillance" v-if="item.type === 'video_surveillance'">
                    <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/video_surveillance',1,$event)"
                               @end="onEnd('/video_surveillance',1,2,$event)" :sort="false">
                      <div @contextmenu.prevent="onContextmenu($event,2, '/video_surveillance')" class="more_content" @click="changeSelInHidden('18')" @mouseover="changeImg('enter','17')"
                           @mouseout="changeImg('out','18')" :class="[isActiveInHidden==='18'?'activeInHidden':'']">
                        <!--<Badge :count="videoCount">
                          <img class="more_icon" :src="videoMonitor">
                        </Badge>-->
                        <div class="more_icon_desc">
                          <Badge :count="videoCount">
                            {{$t('video_surveillance')}}
                          </Badge>
                        </div>
                      </div>
                    </draggable>
                  </router-link>
                  <!--报表管理-->
                  <router-link to="/report" v-if="item.type === 'report'">
                    <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/report',1,$event)"
                               @end="onEnd('/report',1,2,$event)" :sort="false">
                      <div @contextmenu.prevent="onContextmenu($event,2, '/report')" class="more_content" @click="changeSelInHidden('20')" @mouseover="changeImg('enter','20')"
                           @mouseout="changeImg('out','20')" :class="[isActiveInHidden==='20'?'activeInHidden':'']">
                        <!--<Badge :count="messageCount">
                          <img class="more_icon" :src="upInfoInit">
                        </Badge>-->
                        <div class="more_icon_desc">
                          {{$t('report.menu')}}
                        </div>
                      </div>
                    </draggable>
                  </router-link>
                  <!--频道会话-->
                  <router-link to="/chatChannel" v-if="item.type ==='chatChannel'">
                    <draggable choseClass="chose" forceFallback="true" animation="1000" @start="onStart('/chatChannel',1,$event)" @end="onEnd('/chatChannel',1,2,$event)" :sort="false">
                      <div @contextmenu.prevent="onContextmenu($event,2,'/chatChannel')" class="more_content" @click="changeSelInHidden('21')"
                           @mouseover="changeImg('enter','21')" @mouseout="changeImg('out','21')" :class="[isActiveInHidden==='21'?'activeInHidden':'']">
                        <div class="more_icon_desc">
                          <Badge :count="channelCount">
                            {{$t('more_menu_channel')}}
                          </Badge>
                        </div>
                      </div>
                    </draggable>

                  </router-link>
                  <a href="javascript:void('');" class="">
                    <draggable chosenClass="chosen" forceFallback="true" animation="1000"
                               @start="onStart('/no',1,$event)"
                               @end="onEnd('/no',1,2,$event)" :sort="false">
                    <div @contextmenu.prevent="onContextmenu($event,2, '/no')" class="more_content" @click="changeSelInHidden('11')" v-if="item.type === 'system'"
                         @mouseover="changeImg('enter','11')" @mouseout="changeImg('out','11')"
                         :class="[isActiveInHidden==='11'?'activeInHidden':'']">
                      <div class="more_icon_desc">{{$t('more_menu_system')}}</div>
                    </div>
                    </draggable>
                  </a>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>

          </div>
          <!--</router-link>-->
        </div>
      </div>
    </div>

    <div id="sys_btn_group" class="sys_btn_group" :style="{'width':(has_emergency_width /80) +'rem','float':'right'}">
      <div class="sys_btn">
        <Tooltip :content="$t(isConnected?`serverconnected`:`serverunconnected`)" class="tip" offset="-8">
          <svg-icon :iconClass="isConnected?connected_svg:unconnected_svg" className="icon"></svg-icon>
        </Tooltip>
        <User @monitorOpenclose="monitorOpenclose" :user-avatar="userAvatar" :showAuto="showAuto"
              :supportVideo="supportVideo" :userId="userId" :userAccount="userAccount"></User>
      </div>

      <div class="em" style="display: flex;justify-content: space-between;align-items: center;margin-top: 0.25rem;">

        <div>
        <div class="em-one" @mouseover="changeImg('enter','12')" @mouseout="changeImg('out','12')" @click="showBroad">
          <div v-show="this.menuArr[5] && hasRole('all_permissions.emergency_broadcast')" class="em-one-icon"><img :src="emergencyInit"></div>
          <div v-show="this.menuArr[5] && hasRole('all_permissions.emergency_broadcast')" class="em-one-font" :title="$t('emergency')">{{emergencyBroad.running ? $t('emergency_running'):$t('emergency')}}</div>
        </div>
        <div class="icon_font number-font em-two-time">{{time2}}</div>
        </div>
        <div style=" display: flex;flex-direction: column;justify-content: flex-end;margin-left: 0.15rem;width: 1.3rem;">

          <div class="em-two">
            <div class="top_icon number-font em-two-date" style="text-align: center;">{{ week }}</div>
          </div>
          <div class="em-two">
            <div class="top_icon number-font em-two-date" style="text-align: center;">{{time1}}</div>
          </div>

        </div>
      </div>

    </div>
    <div id="addMoreMenus" v-show="drag"
      style="position: absolute; width: 400px; height: 300px; border: 5px dashed #2d8cf0; left: 40%; z-index: 999;
             text-align: center; line-height: 250px; font-size: 30px; color: #2d8cf0; background-color: rgba(45 140 240,0.20);">{{$t('add_to_more')}}</div>
    <EmergencyPop :showEmergencyPop="showEmergencyPop" @closeBroad="closeBroad"></EmergencyPop>

  </div>
</template>

<script>
import fourBlockWhiteInit from '@/assets/images/top/fourBlockWhite.png'
import conferenceRoomInit from '@/assets/images/top/conferenceRoom.png'
import hornInit from '@/assets/images/top/horn.png'
import standGuardInit from '@/assets/images/top/standGuard.png'
import standGuard from '@/assets/images/top/standGuard.png'
import warningInit from '@/assets/images/top/warning.png'
import warning from '@/assets/images/top/warning.png'
import videoInit from '@/assets/images/top/video.png'
import video from '@/assets/images/top/video.png'
import mapInit from '@/assets/images/top/map.png'
import map from '@/assets/images/top/map.png'
import reservePlanInit from '@/assets/images/top/reservePlan.png'
import queuingNoticeInit from '@/assets/images/top/notice.png'
import contactsInit from '@/assets/images/top/contacts.png'
import contacts from '@/assets/images/top/contacts.png'
import systemInit from '@/assets/images/top/system.png'
import system from '@/assets/images/top/system.png'
import upInfoInit from '@/assets/images/top/upInfo.png'
import selfCheckInit from '@/assets/images/top/self_check.png'
import hourlyChime from '@/assets/images/top/hourlyChime.png'
import cascadeManager from '@/assets/images/top/duojijilian.png'
import videoMonitor from '@/assets/images/top/videoMonitor.png'
import moreInit from '@/assets/images/top/more.png'
import emergencyInit from '@/assets/images/top/emergencyBroadcast.png'
import userImg from '@/assets/images/login/timg.jpg'

import Language from '../language'
import Fullscreen from '../fullscreen'
import User from '../user'
import {mapMutations, mapActions} from 'vuex'
import {localSave, localRead, hasRole} from '@/libs/util'
import {queryEmergencyBroad} from '@/api/broadcast.js'
import {getFormatDate,isFull} from '@/libs/tools'
import {getSystemTime} from '@/api/data'
import {baseImg} from '@/libs/base'
import {findUserConfig,saveUserConfig} from '@/api/userSetting.js'
import draggable from 'vuedraggable'
import BroadConfig from "@/view/broadcast/broad-config.vue";
import EmergencyPop from "../emergency-pop/emergency-pop.vue";

export default {
  name: 'HeaderBar',
  mixins: [baseImg],
  components: {
    EmergencyPop,
    BroadConfig,
    User, Fullscreen, Language, draggable,//注册draggable组件
  },
  props: {
    messageCount: {
      type: Number,
      default: 0
    },
    showAuto: {
      type: Boolean,
      default: false
    },
    supportVideo: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String | Number
    },
    userAccount: {
      type: String,
      default: ''
    },
    videoCount: {
      type: Number,
      default: 0
    },
    currentRoute:{
      type:String,
      default:null
    },
    serverTime:{
      type:String,
      default:null
    }
  },
  data() {
    return {
      week:'',
      weekArray:new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"),
      weekArrayEN:new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"),
      showMean:true,
      visible:false,
      configValue:{},
      hiddenMenu:[],
      menuOrder:[],
      // showMore:false,
      menuShow: false, //v-show标识隐藏显示
      drag: false,

      time1: '',//getFormatDate('YYYY-mm-dd',new Date())
      time2: '',//getFormatDate('HH:MM:SS',new Date())
      fourBlockWhiteInit: fourBlockWhiteInit,
      conferenceRoomInit: conferenceRoomInit,
      hornInit: hornInit,
      standGuardInit: standGuardInit,
      warningInit: warningInit,
      videoInit: videoInit,
      mapInit: mapInit,
      reservePlanInit: reservePlanInit,
      queuingNoticeInit: queuingNoticeInit,
      contactsInit: contactsInit,
      systemInit: systemInit,
      upInfoInit: upInfoInit,
      selfCheckInit: selfCheckInit,
      hourlyChime:hourlyChime,
      cascadeManager:cascadeManager,
      videoMonitor:videoMonitor,
      emergencyInit: emergencyInit,
      moreInit: moreInit,
      isFullscreen: false,
      menuArr: [false, false, false, true, false, false, false, false, false, false],
      menuRoleArr: [
        'all_permissions.main_console',//主控台
        'all_permissions.conference_room',//会议室
        'all_permissions.broadcast_mission',//广播任务
        'all_permissions.unattended',//无人值守
        'all_permissions.merge_alarm_plan',//报警预案
        'all_permissions.video',//视屏
        'all_permissions.electronic_map',//电子地图
        'all_permissions.plan',//预案
        'all_permissions.scheduling_notification',//调度通知
        'all_permissions.contact',//联系人
        'all_permissions.reported_information',//上报信息
        'all_permissions.self_check',
        'all_permissions.system_administration',//系统管理
        'all_permissions.hourly_chime',//整点报时
        'all_permissions.cascade',//级联管理
        'all_permissions.monitor',//监视
        'all_permissions.communication_dispatching',//调度通讯
        'all_permissions.report_form',//报表管理
        'all_permissions.chat',//频道会话
      ],
      //菜单项及对应顺序(全部)
      menuItemAndOrder: [],
      //显示的菜单项
      displayMenuItem: [],
      //隐藏在显示更多
      hiddenMenuItem: [],
      //每个菜单的最先宽度 100px
      menuMinWidth: 1.5,
      //outerPaddingLeft 控制居中
      outerPaddingLeft: 0,
      innerWidth: 0,
      has_emergency: true,//默认含有紧急广播
      has_emergency_width: 295,//默认含有紧急广播的的右侧导航的整个宽度，不含有紧急广播则195
      hasMoreMenu: false,//标识是否有更多菜单
      childHover: false,//更多下子项是否hover，子选中则更多选中
      connectInfo: '未连接',
      lastTime: 1,//上一次的选中菜单
      monitorOpen: '',//视频打开对象
      electronicMap: '',//电子地图
      videoCallMap: '',//视频监视打开对象
      defaultHeight:1.1875,
      height:1.1875,
      fullHeight:1.4875,
      touchStart:{},
      interval: null,
      syncTimer: null,
      emergencyBroad:{},
      showEmergencyPop:false,
    }
  },
  methods: {
    showBroad(){
      this.showEmergencyPop = true;
    },
    closeBroad(){
      this.showEmergencyPop = false;
    },
    getWeek(){
      let num=this.weekArray[new Date(this.time1).getDay()]
      let lang = this.$store.state.app.local
      if(lang=='zh-CN'){
        this.week=num
      }else if(lang=='zh-TW'){
        this.week=num
      }else{
        num=this.weekArrayEN[new Date(this.time1).getDay()]
        this.week=num
      }
    },
    ...mapMutations([
      'setLocal',
      'setCurrentMenu'
    ]),
    ...mapActions([
      'sendMsg',
      'getSplitScreenWS'
    ]),
    setConfigValue(){
      let type='0';
      if(JSON.stringify(this.configValue) == "{}"){
        type='1';
      }
      let hidden='';
      let order='';
      let hiddenOrder='';

      this.hiddenMenuItem.forEach(item=>{
        if(item.isHidden){
          hidden+=item.type+','
        }else{
          hiddenOrder+=item.type+','
        }
      });
      this.configValue.hiddenMenu=hidden.substring(0,hidden.length-1);

      this.displayMenuItem.forEach(item=>{
        if(item.type !== 'system'){
          order+=item.type+",";
        }
      })
      if(hiddenOrder.length > 0 || hidden.length > 0){
        if(hiddenOrder.length > 0){
          order+=hiddenOrder
        }
        if(hidden.length > 0){
          order+=hidden;
        }
      }
      this.configValue.menuOrder=order.substring(0,order.length-1);
      this.configValue.acceptType=this.$store.state.app.acceptType
      this.configValue.autoAccept=this.$store.state.app.autoAccept
      this.configValue.theme=this.$store.state.app.theme
      this.configValue.display_num=this.$store.state.clickData.row_column_display_num
      this.configValue.language ='zh-CN';
      this.configValue.cameraId = this.$store.state.user.cameraId
      this.configValue.micId = this.$store.state.user.micId
      this.configValue.speakId = this.$store.state.user.speakId
      this.updateUserConfig();
    },
    //添加
    hideMenu:function(param){
      if(this.hiddenMenuItem.length != 0){
        this.innerWidth-=(this.menuMinWidth);
      }

      let temp = this.displayMenuItem.find(item=> item.to == param);
      let index = this.displayMenuItem.findIndex(item=> item.to == param);
      if(index > -1){
          this.displayMenuItem.splice(index,1);
          temp.isHidden=true;
          temp.id+=20
          this.hiddenMenuItem.push(temp);
      }
      this.hiddenMenuItem=this.hiddenMenuItem.sort((pre,cur)=>  pre.id -cur.id);
      this.setConfigValue();
    },
    //移出
    displayMenu:function(param){
      let outerWidth = this.sysWidth - document.getElementById("logoDiv").getBoundingClientRect().width
        - document.getElementById("sys_btn_group").getBoundingClientRect().width;
      let menu_length = this.displayMenuItem.length+2
      let gap = outerWidth - (menu_length * (this.menuMinWidth))
      if(gap <= 0 ){
        this.$Message.info(this.$t('remove_fail'));
        return;
      }
      if(this.hiddenMenuItem.length != 1){
        this.innerWidth+=(this.menuMinWidth);
      }
      let temp = this.hiddenMenuItem.find(item=> item.to == param);
      let index = this.hiddenMenuItem.findIndex(item=> item.to == param);
      if(index > -1){
          this.hiddenMenuItem.splice(index,1);
          temp.isHidden=false;
          this.displayMenuItem.push(temp);
      }
      this.displayMenuItem=this.displayMenuItem.sort((pre,cur)=>  pre.id -cur.id);
      this.setConfigValue();
    },
    monitorOpenclose: function () {
      // console.log(this.monitorOpen)
      if (this.monitorOpen !== '') {
        this.monitorOpen.close()
      }
      if (this.electronicMap !== '') {
        this.electronicMap.close()
      }
      if (this.videoCallMap !== '') {
        this.videoCallMap.close()
      }
    },
    //菜单右键
    onContextmenu(event,showMenu, param) {

      let that = this
      let tilte = ''
      let items=[];
      if(param === '/monitor' || param === '/station' || param === '/video_surveillance'){
        if (this.$i18n.locale === 'zh-CN') {
          tilte = param === '/monitor' ? '新建视频监控窗口' : param === '/video_surveillance' ? '新建监视窗口' : (this.$store.state.user.mapGis ? '新建GIS地图窗口' : '新建电子地图窗口')
        } else if (this.$i18n.locale === 'zh-TW') {
          tilte = param === '/monitor' ? '新建視像監控視窗' : param === '/video_surveillance' ? '新建監視視窗' : (this.$store.state.user.mapGis ? '新建GIS地圖視窗' : '新建電子地圖視窗')
        } else {
          tilte = param === '/monitor' ? 'New Monitor window' : param === '/video_surveillance' ? 'New monitoring window' : (this.$store.state.user.mapGis ? 'New GIS Map window' : 'New Digital Map window')
        }
        items.push({
            label: tilte,
            //icon: "el-icon-refresh",
            onClick: () => {
              that.onEnd(param, 2,showMenu, event)
            },
        });
      }

      let param2=param;
      if(showMenu == 1){
        items.push({
            label: that.$t('add_to_more'),
            //icon: "el-icon-refresh",
            onClick: () => {
              that.hideMenu(param2);
            },
        });
        if(param2 != '/no'){
          let index=this.displayMenuItem.findIndex(item => item.to == param2);
          if(index !== 0){
              items.push({
                label: that.$t('move_forward'),
                //icon: "el-icon-refresh",
                onClick: () => {
                  for (let i = 0; i < that.displayMenuItem.length; i++) {
                    if(that.displayMenuItem[i].to == param2){
                      if(i == 0){
                        that.hideMenu(param2);
                      }else{
                        let temp ={};
                        temp=that.displayMenuItem[i];
                        that.displayMenuItem[i]=that.displayMenuItem[i-1];
                        that.displayMenuItem[i-1]=temp;
                        that.setConfigValue();
                        return;
                      }
                    }
                  }
                },
              });
          }
          let index2=1;
          if(this.displayMenuItem[this.displayMenuItem.length-1].to == '/no'){
            index2=2;
          }
          if(index !== this.displayMenuItem.length-index2){
            items.push({
              label: that.$t('move_back'),
              //icon: "el-icon-refresh",
              onClick: () => {
                for (let i = 0; i < that.displayMenuItem.length; i++) {
                  if(that.displayMenuItem[i].to == param2){
                    if(i == that.displayMenuItem.length-1 || that.displayMenuItem[i+1].to == '/no'){
                      that.hideMenu(param2);
                    }else{
                      let temp ={};
                      temp=that.displayMenuItem[i];
                      that.displayMenuItem[i]=that.displayMenuItem[i+1];
                      that.displayMenuItem[i+1]=temp;
                      that.setConfigValue();
                      return;
                    }
                  }
                }
              },
            });
          }

        }

      }else{
        items.push({
            label: that.$t('remove_more'),
            //icon: "el-icon-refresh",
            onClick: () => {
              that.displayMenu(param2);
            },
        });
      }

      this.$contextmenu({
        items: items,
        event,
        customClass: 'custom-right-menu',
        zIndex: 100000,
        minWidth: 50,
      })
      return false
    },
    start(evt) {
      this.onStart(null,2,evt)
    },
    end(evt) {
     let type = this.displayMenuItem.find(item => item.to == '/no');

      if(type!=undefined && this.displayMenuItem[this.displayMenuItem.length-1].to !== '/no'){
        this.displayMenuItem=this.displayMenuItem.sort((pre,cur)=>  pre.id -cur.id);
      }


      this.displayMenuItem.forEach((item,i)=>{
        if(item.to !== '/no'){
          item.id=i;
        }
      })

      this.onEnd(this.displayMenuItem[evt.newIndex].to,1,1,event);
    },
    //开始拖拽事件
    onStart(param,type, event) {
      if(type ==2){
        $('#addMoreMenus').html(this.$t('add_to_more'));
      }else{
        $('#addMoreMenus').html(this.$t('remove_more'));
      }
      let x;
      let y;
      try {
        x = event.clientX == undefined ?event.originalEvent.clientX:event.clientX;
        y = event.clientY == undefined ?event.originalEvent.clientY:event.clientY;
      }catch (e) {
        x = event.changedTouches[0].clientX;
        y = event.changedTouches[0].clientY;
      }
      this.touchStart.x = x
      this.touchStart.y = y
      this.drag = true
    },
    //拖拽结束事件
    onEnd(param, type,showMenu, event) {
          if(this.visible){
            this.visible=false;
            let that=this;
            setTimeout(function(){
              that.visible=true;
            },200);
          }
          this.drag = false
          var div = document.getElementById("addMoreMenus");
          var x;
          var y;
          try {
            x = event.clientX == undefined ?event.originalEvent.clientX:event.clientX;
            y = event.clientY == undefined ?event.originalEvent.clientY:event.clientY;
          }catch (e) {
            x = event.changedTouches[0].clientX;
            y = event.changedTouches[0].clientY;
          }

          var divx1 = div.offsetLeft;
          var divy1 = div.offsetTop;
          var divx2 = div.offsetLeft + div.offsetWidth;
          var divy2 = div.offsetTop + div.offsetHeight;
          let noMove = Math.abs(x - this.touchStart.x) < 10 && Math.abs(y - this.touchStart.y) < 10
      if (noMove) {
        if (param == '/no') {
          this.toNewControl()
          return
        }
        if (param == this.currentRoute) {
          return
        }
        let item = this.displayMenuItem.filter(item=>item.to==param)
        if (item && item.length>0 && item[0].change) {
          this.changeSel(item[0].change)
          return
        }
      }
          if(!(x < divx1 || x > divx2 || y < divy1 || y > divy2)){
            let param2=param;
            if(showMenu == 1){
              this.hideMenu(param2);
            }else{
              this.displayMenu(param2);
            }
            return;
          }else{
            if(param != '/monitor' && param != '/station' && param != '/video_surveillance'){
              if(y <= 130){
                this.setConfigValue();
              }
              return;
            }
          }

        if (type === 1) {
          //判断鼠标的位置
          if (y <= 130) {
             this.setConfigValue();
              return;
          }
        }

      let contentHeight = document.documentElement.clientHeight
      let contentWidth = document.documentElement.clientWidth
      let strWindowFeatures = 'location=no,menubar=no,status=no,resizable=no,titalebar=yes,width=' + contentWidth + ',height=' + contentHeight
      let tilte = param === '/monitor' ? '视频' : param === '/video_surveillance' ? 'surveillance' : '电子地图'
      if (tilte === '视频') {
        const routeData = this.$router.resolve({
          path: '/monitor_split_screen',
          query: {type: true}
        })
        // console.log(this.monitorOpen)
        if (this.monitorOpen !== '') {
          if (this.monitorOpen.name !== '') {
            this.monitorOpen.focus()
            return
          }
        }
        if (type === 1) {
          this.monitorOpen = window.open(routeData.href, 'monitor_split_screen', strWindowFeatures)
        } else if (type === 2) {
          this.monitorOpen = window.open(routeData.href, 'monitor_split_screen')
        }


      } else if (tilte === '电子地图') {
        const routeData2 = this.$router.resolve({
          path: '/station_split_screen',
          query: {type: true}
        })
        if (this.electronicMap !== '') {
          if (this.electronicMap.name !== '') {
            this.electronicMap.focus()
            return
          }
        }
        if (type === 1) {
          this.electronicMap = window.open(routeData2.href, 'station_split_screen', strWindowFeatures)
        } else if (type === 2) {
          this.electronicMap = window.open(routeData2.href, 'station_split_screen')
        }

      } else if (tilte === 'surveillance') {
        const routeData3 = this.$router.resolve({
          path: '/surveillance_split_screen',
          query: {type: true}
        })
        if (this.videoCallMap !== '') {
          if (this.videoCallMap.name !== '') {
            this.videoCallMap.focus()
            return
          }
        }
        if (type === 1) {
          this.videoCallMap = window.open(routeData3.href, 'station_split_screen', strWindowFeatures)
        } else if (type === 2) {
          this.videoCallMap = window.open(routeData3.href, 'station_split_screen')
        }
      }

      localStorage.setItem('monitorOpen', true)
    },

    showDropdownMenu(val) {
      // alert(""+val)
      this.childHover = !this.childHover
    },
    hasRole: function (role) {
      return hasRole(role)
    },
    changeSel: function (index) {
      if(index === '1'){//清除选中的终端
        let yuneasyStore = new BroadcastChannel('yuneasyStore');
        let store = {
          type: 10
        }
        yuneasyStore.postMessage(store);
      }
      if(index === '7'){//清除选中的终端
        let yuneasyStore = new BroadcastChannel('yuneasyStore');
        let store = {
          type: 11
        }
        yuneasyStore.postMessage(store);
      }
      if(index === '14'){
        this.visible=!this.visible;
      }else if(index !== '14-onlyClearOther'){
        this.visible=false;
      }
      if(index !== "11" && index !== "14" && index != '14-onlyClearOther'){
        let temp = this.displayMenuItem.find(item => item.change == index);
        this.$router.push(temp.to);
      }
      this.lastTime = this.isActive
      // if(index === '14'){
      //   this.showMore=this.showMore===true?false:true;
      // }
      if (index === '11') {
        if(!this.$store.state.user.systemRole){
          this.$Message.warning(this.$t('system_role'))
          return;
        }
        this.toNewControl()
      } else {
        if (index !== '14') {//点击更多不取消状态

          if (index === '14-onlyClearOther') {//显示更多下面的菜单点击触发，不清空菜单状态
            this.isActive = '14'
            this.$store.commit('setMenuId', '14')
          } else {//除开显示更多的菜单点击触发，
            this.isActive = index
            this.$store.commit('setMenuId', index)
            //清除隐藏菜单选中状态
            this.$store.commit('setHiddenMenuId', '')
            localSave('currentMenuInHidden', '')
            //分屏窗口关闭
            if (index === '6' && this.monitorOpen !== '' && this.monitorOpen.name !== '') {
              this.monitorOpen.focus()
              return
            } else if (index === '7' && this.electronicMap !== '' && this.electronicMap.name !== '') {
              this.electronicMap.focus()
              return
            }
            //关闭store监控传递
            if ((this.electronicMap === '' || this.electronicMap.name === '') &&
              (this.monitorOpen === '' || this.monitorOpen.name === '')) {
              localStorage.setItem('monitorOpen', false)
            }
          }


        }

      }
    },
    changeSelInHidden: function (index) {
      if(index !== "11" && index !== "14"){
        let temp = this.hiddenMenuItem.find(item => item.change == index);
        this.$router.push(temp.to);
      }
      if (index === '11') {
        if(!this.$store.state.user.systemRole){
          this.$Message.warning(this.$t('system_role'))
          return;
        }
        this.toNewControl()
      } else {
        //显示的菜单,显示更多
        this.changeSel('14-onlyClearOther')
        this.isActiveInHidden = index
        this.$store.commit('setHiddenMenuId', index)
      }
      this.visible=false;
    },
    async queryEmBroad() {
      await queryEmergencyBroad().then(res=>{
        this.emergencyBroad = {
          running:false
        }
        let response = res.data
        if (response.code == 200) {
          this.emergencyBroad = response.data ? response.data : {}
          if (this.emergencyBroad.status == 1 || this.emergencyBroad.status == 2) {
            this.emergencyBroad.running = true
          } else {
            this.emergencyBroad.running = false
          }
        }
      }).catch(err=>{
        this.emergencyBroad = {
          running:false
        }
      })
    },
    changeImg: function (sign, index) {
    },
    initMenuRole() {
      //清楚测试格式数据
      this.menuItemAndOrder = []
      this.displayMenuItem = []
      this.hiddenMenuItem = []
      //获取有序的菜单权限
      let role = localRead('role')

      let role_arr = role.split(',')
      if (role_arr.length > 0) {

        let addSystem = false
        for (let index = 0; index < role_arr.length; index++) {
          const element = role_arr[index]
          let index_menuRoleArr = this.IndexOf(this.menuRoleArr, element)

          if (index_menuRoleArr != -1) {//一级菜单权限
            if (index_menuRoleArr == 0) {//主控台
              let tempMap = {}
              tempMap.to = '/control'
              tempMap.footerName = 'control'
              tempMap.type = 'control'
              tempMap.menuId = '1'
              tempMap.id = 1
              tempMap.change='1';
              tempMap.menu=8;
              tempMap.title='control';
              tempMap.src=this.fourBlockWhiteInit;
              tempMap.isHidden=false;
              //判断是否有license
              if (this.menuArr[8]) {
                this.menuItemAndOrder.push(tempMap)
                if(this.$store.state.user.homeName === 'control' && window.location.pathname.indexOf('/control') > 0){
                  this.isActive = '1'
                  this.$store.commit('setMenuId', '1')
                }
                //通知设置显示行列
                this.$store.commit('setHasCotrolOrConfRole', true)
              }
            }
            if (index_menuRoleArr == 1) {//会议室
              let tempMap = {}
              tempMap.to = '/conference'
              tempMap.footerName = 'conference'
              tempMap.type = 'conference'
              tempMap.menuId = '2'
              tempMap.id = 2
              tempMap.change='2';
              tempMap.menu=7;
              tempMap.title='conference';
              if(this.$store.state.user.videoConf > 0){
                tempMap.title='videoConference';
              }
              tempMap.src=this.conferenceRoomInit;
              tempMap.isHidden=false;
              //判断是否有license
              if (this.menuArr[7]) {
                this.$store.commit('setHaveVoiceConf',true)
                this.menuItemAndOrder.push(tempMap)
                if(this.$store.state.user.homeName === 'conference' && window.location.pathname.indexOf('/conference') > 0){
                  this.isActive = '2'
                  this.$store.commit('setMenuId', '2')
                }
                //通知设置显示行列
                this.$store.commit('setHasCotrolOrConfRole', true)
              }
            }
            if (index_menuRoleArr == 2) {//广播任务
              let tempMap = {}
              tempMap.to = '/broadcast'
              tempMap.footerName = 'broadcast'
              tempMap.type = 'broadcast'
              tempMap.menuId = '3'
              tempMap.id = 3
              tempMap.change='3';
              tempMap.menu=5;
              tempMap.title='broadcast';
              tempMap.src=this.hornInit;
              tempMap.isHidden=false;
              //判断是否有license
              if (this.menuArr[5]) {
                this.menuItemAndOrder.push(tempMap)
                if(this.$store.state.user.homeName === 'broadcast' && window.location.pathname.indexOf('/broadcast') > 0){
                  this.isActive = '3'
                  this.$store.commit('setMenuId', '3')
                }
              }

            }
            if (index_menuRoleArr == 3) {//无人值守
              let tempMap = {}
              tempMap.to = '/unattended'
              tempMap.footerName = 'standGuard'
              tempMap.type = 'unattended'
              tempMap.menuId = '4'
              tempMap.id = 4
              tempMap.change='4';
              tempMap.menu=-1;
              tempMap.title='standGuard';
              tempMap.src=this.standGuardInit;
              tempMap.isHidden=false;
              this.menuItemAndOrder.push(tempMap)
              if(this.$store.state.user.homeName === 'unattended' && window.location.pathname.indexOf('/unattended') > 0){
                this.isActive = '4'
                this.$store.commit('setMenuId', '4')
              }
            }
            if (index_menuRoleArr == 4) {//报警
              let tempMap = {}
              tempMap.to = '/alarm'
              tempMap.footerName = 'warning'
              tempMap.type = 'merge_alarm_plan'
              tempMap.menuId = '5'
              tempMap.id = 11
              tempMap.change='5';
              tempMap.menu=1;
              tempMap.title='more_menu_warning';
              tempMap.src=this.warningInit;
              tempMap.isHidden=false;
              //判断是否有license
              if (this.menuArr[1]) {
                this.menuItemAndOrder.push(tempMap)
                if(this.$store.state.user.homeName === 'alarm' && window.location.pathname.indexOf('/alarm') > 0){
                  this.isActive = '5'
                  this.$store.commit('setMenuId', '5')
                }
              }
            }
            if (index_menuRoleArr == 5) {//视屏
              let tempMap = {}
              tempMap.to = '/monitor'
              tempMap.footerName = 'video'
              tempMap.type = 'monitor'
              tempMap.menuId = '6'
              tempMap.id = 5
              tempMap.change='6';
              tempMap.menu=0;
              tempMap.title='video';
              tempMap.src=this.videoInit;
              tempMap.isHidden=false;
              //判断是否有license
              if (this.menuArr[0]) {
                this.menuItemAndOrder.push(tempMap)
                if(this.$store.state.user.homeName === 'monitor' && window.location.pathname.indexOf('/monitor') > 0){
                  this.isActive = '6'
                  this.$store.commit('setMenuId', '6')
                }
              }
            }
            if (index_menuRoleArr == 6) {//电子地图
              let tempMap = {}
              tempMap.to = '/station'
              tempMap.footerName = 'map'
              tempMap.type = 'station'
              tempMap.menuId = '7'
              tempMap.id = 6
              tempMap.change='7';
              tempMap.menu=2;
              tempMap.title = this.$store.state.user.mapGis ? 'more_menu_gis_map' : 'map'
              tempMap.src=this.mapInit;
              tempMap.isHidden=false;
              //判断是否有license
              if (this.menuArr[2]) {
                this.menuItemAndOrder.push(tempMap)
                if(this.$store.state.user.homeName === 'station' && window.location.pathname.indexOf('/station') > 0){
                  this.isActive = '7'
                  this.$store.commit('setMenuId', '7')
                }
              }
            }
            // if (index_menuRoleArr == 7) {//预案
            //   let tempMap = {}
            //   tempMap.to = '/action_plan'
            //   tempMap.footerName = 'reserve_plan'
            //   tempMap.type = 'action_plan'
            //   tempMap.menuId = '8'
            //   tempMap.id = 11
            //   //判断是否有license
            //   if (this.menuArr[1]) {
            //     this.menuItemAndOrder.push(tempMap)
            //   }
            // }
            if (index_menuRoleArr == 8) {//调度通知
              let tempMap = {}
              tempMap.to = '/notice'
              tempMap.footerName = 'queuing_notice'
              tempMap.type = 'notice'
              tempMap.menuId = '9'
              tempMap.id = 7
              tempMap.change='9';
              tempMap.menu=-1;
              tempMap.title='queuing_notice';
              tempMap.src=this.queuingNoticeInit;
              tempMap.isHidden=false;
              this.menuItemAndOrder.push(tempMap)
              if(this.$store.state.user.homeName === 'notice' && window.location.pathname.indexOf('/notice') > 0){
                this.isActive = '9'
                this.$store.commit('setMenuId', '9')
              }
            }
            if (index_menuRoleArr == 9) {//联系人
              let tempMap = {}
              tempMap.to = '/linkman'
              tempMap.footerName = 'contacts'
              tempMap.type = 'linkman'
              tempMap.menuId = '10'
              tempMap.id = 8
              tempMap.change='10';
              tempMap.menu=-1;
              tempMap.title='contacts';
              tempMap.src=this.contactsInit;
              tempMap.isHidden=false;
              this.menuItemAndOrder.push(tempMap)
              if(this.$store.state.user.homeName === 'linkman' && window.location.pathname.indexOf('/linkman') > 0){
                this.isActive = '10'
                this.$store.commit('setMenuId', '10')
              }
            }
            if (index_menuRoleArr == 10) {//上报信息
              let tempMap = {}
              tempMap.to = '/reporting_information'
              tempMap.footerName = 'reporting_information'
              tempMap.type = 'reporting_information'
              tempMap.menuId = '13'
              tempMap.id = 9
              tempMap.change='13';
              tempMap.menu=-1;
              tempMap.title='reporting_information';
              tempMap.src=this.upInfoInit;
              tempMap.isHidden=false;
              this.menuItemAndOrder.push(tempMap)
              if(this.$store.state.user.homeName === 'reporting_information' && window.location.pathname.indexOf('/reporting_information') > 0){
                this.isActive = '13'
                this.$store.commit('setMenuId', '13')
              }
            }
            if (index_menuRoleArr == 11) {
              let tempMap = {}
              tempMap.to = '/self_check'
              tempMap.footerName = 'self_check'
              tempMap.type = 'self_check'
              tempMap.menuId = '15'
              tempMap.id = 10
              tempMap.change='15';
              tempMap.menu=-1;
              tempMap.title='self_check';
              tempMap.src=this.selfCheckInit;
              tempMap.isHidden=false;
              this.menuItemAndOrder.push(tempMap)
              if(this.$store.state.user.homeName === 'self_check' && window.location.pathname.indexOf('/self_check') > 0){
                this.isActive = '15'
                this.$store.commit('setMenuId', '15')
              }
            }
            if (index_menuRoleArr == 12) {//系统管理
              addSystem = true
            }
            if (index_menuRoleArr == 13 && false) {//整点报时
              let tempMap = {}
              tempMap.to = '/hourly_chime'
              tempMap.footerName = 'hourly_chime'
              tempMap.type = 'hourly_chime'
              tempMap.menuId = '16'
              tempMap.id = 12
              tempMap.change='16';
              tempMap.menu=-1;
              tempMap.title='hourly_chime';
              tempMap.src=this.hourlyChime;
              tempMap.isHidden=false;
              this.menuItemAndOrder.push(tempMap)
              if(this.$store.state.user.homeName === 'hourly_chime' && window.location.pathname.indexOf('/hourly_chime') > 0){
                this.isActive = '16'
                this.$store.commit('setMenuId', '16')
              }
            }
            if (index_menuRoleArr == 14) {//级联管理
              let tempMap = {}
              tempMap.to = '/cascade'
              tempMap.footerName = 'cascade_manager'
              tempMap.type = 'cascade_manager'
              tempMap.menuId = '17'
              tempMap.id = 0
              tempMap.change='17';
              tempMap.menu=-1;
              tempMap.title='cascade_manager';
              tempMap.src=this.cascadeManager;
              tempMap.isHidden=false;
              //级联管理不需要判断是否有license
              // if (this.menuArr[12]) {
                this.menuItemAndOrder.unshift(tempMap)
                if(this.$store.state.user.homeName === 'cascade' && window.location.pathname.indexOf('/cascade') > 0){
                  this.isActive = '17'
                  this.$store.commit('setMenuId', '17')
                }
              // }
            }
            if (index_menuRoleArr == 15) {//视频监视
              let tempMap = {}
              tempMap.to = '/video_surveillance'
              tempMap.footerName = 'video_surveillance'
              tempMap.type = 'video_surveillance'
              tempMap.menuId = '18'
              tempMap.id = 14
              tempMap.change='18';
              tempMap.menu=-1;
              tempMap.title='video_surveillance';
              tempMap.src=this.videoMonitor;
              tempMap.isHidden=false;
              //判断是否有license
              if (this.menuArr[14]) {
                this.$store.commit('setHasMonitor', true);
                this.menuItemAndOrder.push(tempMap)
                if(this.$store.state.user.homeName === 'video_surveillance' && window.location.pathname.indexOf('/video_surveillance') > 0){
                  this.isActive = '18'
                  this.$store.commit('setMenuId', '18')
                }
              }
            }
            if (index_menuRoleArr == 16) {
              let tempMap = {}
              tempMap.to = '/dispatch'
              tempMap.footerName = 'dispatch'
              tempMap.type = 'dispatch'
              tempMap.menuId = '19'
              tempMap.id = 0.5
              tempMap.change = '19'
              tempMap.menu = -1
              tempMap.title = 'more_menu_dispatch'
              tempMap.src = ''
              tempMap.isHidden = false
              //判断是否有license
              if (this.$store.state.user.isDispatch) {
                //this.$store.commit('setHasMonitor', true)
                this.menuItemAndOrder.push(tempMap)
                if (this.$store.state.user.homeName === 'dispatch' && window.location.pathname.indexOf('/dispatch') > 0) {
                  this.isActive = '19'
                  this.$store.commit('setMenuId', '19')
                }
              }
            }
            if (index_menuRoleArr == 17) {
              let tempMap = {}
              tempMap.to = '/report'
              tempMap.footerName = 'report'
              tempMap.type = 'report'
              tempMap.menuId = '20'
              tempMap.id = 20
              tempMap.change = '20'
              tempMap.menu = -1
              tempMap.title = 'report.menu'
              tempMap.src = ''
              tempMap.isHidden = false
              this.menuItemAndOrder.push(tempMap)
              if (this.$store.state.user.homeName === 'report' && window.location.pathname.indexOf('/report') > 0) {
                this.isActive = '20'
                this.$store.commit('setMenuId', '20')
              }
            }
            if (index_menuRoleArr == 18) {//频道会话
              let tempMap = {}
              tempMap.to = '/chatChannel'
              tempMap.footerName = 'chatChannel'
              tempMap.type = 'chatChannel'
              tempMap.menuId = '21'
              tempMap.id = 21
              tempMap.change='21';
              tempMap.menu=-1;
              tempMap.title='more_menu_channel';
              tempMap.src="";
              tempMap.isHidden=false;
              //判断是否有license
              if (this.$store.state.user.haveChannel) {
                this.menuItemAndOrder.push(tempMap)
                if (this.$store.state.user.homeName === 'chatChannel' && window.location.pathname.indexOf('/chatChannel') > 0) {
                  this.isActive = '21'
                  this.$store.commit('setMenuId', '21')
                }
              }
            }
          }

        }
        //系统管理默认最后一个
        if (addSystem) {
          let tempMap = {}
          tempMap.to = '/no'
          tempMap.footerName = 'system'
          tempMap.type = 'system'
          tempMap.menuId = '12'
          tempMap.id = 10000
          tempMap.change='11';
          tempMap.menu=-1;
          tempMap.title='system';
          tempMap.src=this.systemInit;
          tempMap.isHidden=false;
          this.menuItemAndOrder.push(tempMap)
        }

      }
      let hidden=[];
      if(this.hiddenMenu.length>0 || this.menuOrder.length>0){
        for (let i = 0; i < this.menuItemAndOrder.length; i++) {
          let type = this.menuItemAndOrder[i].type;
          //排序
          if(this.menuOrder.length>0 && type !== "system"){
            let index = this.menuOrder.findIndex(item3=> item3 == type);
            if (index > -1) {
              this.menuItemAndOrder[i].id=index+1
            }
          }

          //去除隐藏的菜单
          let temp = this.hiddenMenu.find(item2=> item2 == type);
          if(temp != undefined){
            hidden.push(this.menuItemAndOrder[i]);
            this.menuItemAndOrder.splice(i,1);
            i--;
          }
        }
      }
      this.menuItemAndOrder=this.menuItemAndOrder.sort((pre,cur)=>  pre.id -cur.id);
      //处理哪些菜单显示 this.displayMenuItem，哪些菜单隐藏 this.hiddenMenuItem
      //每个菜单的最小宽度
      //检测是否含有紧急广播权限
      // 经测试，没紧急广播时，把宽度调整后，会将时间也去除，故将默认拥有紧急广播。
      this.has_emergency = true;
      // this.has_emergency_width = this.has_emergency ? 295 : 195
      this.has_emergency_width = this.has_emergency ? 350 : 195
      let outerWidth = this.sysWidth - document.getElementById("logoDiv").getBoundingClientRect().width
        - document.getElementById("sys_btn_group").getBoundingClientRect().width;
      let menu_length = this.menuItemAndOrder.length
      this.menuMinWidth = document.getElementById("mean_for_width").getBoundingClientRect().width;
      let gap = outerWidth - (menu_length * (this.menuMinWidth))
      this.showMean = false;
      gap=gap-(this.menuMinWidth);
      if (gap > 0) {//可容纳
        this.displayMenuItem = this.menuItemAndOrder
        this.innerWidth = (this.menuMinWidth) * menu_length
        //  this.outerPaddingLeft = gap / 2 ;
        //20210507 修改为居左显示
        this.outerPaddingLeft = 0
      } else {//不可容纳
        //标识存在更多菜单
        this.hasMoreMenu = true
        let display_max_length = Math.floor(outerWidth / (this.menuMinWidth))
        this.hiddenMenuItem = this.menuItemAndOrder.splice(display_max_length - 1)
        this.displayMenuItem = this.menuItemAndOrder

        //修改innerwidth padding
        this.innerWidth = (this.menuMinWidth) * display_max_length + 1;
        gap = outerWidth - (display_max_length * (this.menuMinWidth))
        if (gap > 0) {//均分
          //this.outerPaddingLeft = gap / 2 ;
          //20210507 修改为居左显示
          this.outerPaddingLeft = 0
        }
      }
      if(hidden.length > 0){
        if(this.hiddenMenuItem.length == 0){
          this.innerWidth+=(this.menuMinWidth);
        }
        hidden.forEach(item=>{
          item.id+=20;
          item.isHidden=true;
          this.hiddenMenuItem.push(item);
        });
      }
      this.hiddenMenuItem=this.hiddenMenuItem.sort((pre,cur)=>  pre.id -cur.id);
      this.displayMenuItem=this.displayMenuItem.sort((pre,cur)=>  pre.id -cur.id);
    },
    IndexOf(arr, item) {
      if (Array.prototype.indexOf) {
        return arr.indexOf(item)
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] === item) {
            return i
          }
        }
      }
      return -1
    },
    //获取用户的菜单状态
    getUserConfig(){
      findUserConfig().then(res => {
        let response = res.data
        if (response.code == 200) {
          this.configValue = response.data;
          if(JSON.stringify(this.configValue) !== "{}"){
            if(this.configValue.hiddenMenu != undefined && this.configValue.hiddenMenu != ''){
              this.hiddenMenu=response.data.hiddenMenu.split(',');
              this.$store.commit('setHiddenMenu',response.data.hiddenMenu)
            }
            if(this.configValue.menuOrder != undefined && this.configValue.menuOrder != ''){
              this.menuOrder=response.data.menuOrder.split(',');
              this.$store.commit('setMenuOrder',response.data.menuOrder)
            }
            //设置用户默认设备选中
            this.$store.commit('setCameraId',(response.data.cameraId?response.data.cameraId:null))
            this.$store.commit('setSpeakId',(response.data.speakId?response.data.speakId:null))
            this.$store.commit('setMicId',(response.data.micId?response.data.micId:null))

            //通知加载数据
            this.$root.bus.$emit('loadDevices')

            let autoAccept = this.configValue.autoAccept
            let acceptType = !this.configValue.acceptType ? 'auto' : this.configValue.acceptType
            this.$store.commit('setAcceptType',acceptType)
            this.$store.commit('setAutoAccept',autoAccept)
            let openPanelConfig = response.data.openPanelConfig == null || response.data.openPanelConfig.length === 0 ? ['call-info', 'call-queue', 'no-answer'] : response.data.openPanelConfig;
            if(openPanelConfig && openPanelConfig.length > 0){
              let index = openPanelConfig.findIndex(i => i === 'none');
              if(index !== -1){
                openPanelConfig.splice(index,1)
              }
            }
            this.$store.commit('setOpenPanelConfigNoChange', openPanelConfig)
            this.$store.commit('setOpenPanelConfig', openPanelConfig)
          }
        }
        this.initMenuRole()
      }).catch(err => {
        console.log('err', err)
        //失败也要加载
        this.$root.bus.$emit('loadDevices')
      })
    },
    //修改用户的菜单状态
    updateUserConfig(){
      saveUserConfig(this.configValue).then(res=>{
        let response = res.data
        if (response.code == 200) {
          this.$Message.success(this.$t('operate_success'))
        }else{
          this.$Message.info(this.$t('fail'));
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    setHeight() {
      this.height = isFull() ? this.fullHeight : this.defaultHeight
      $('#broadcast_head').parent().css('height',`${this.height}rem`)
    },
    showAndSetTime(time) {
      if (!time) {
        return
      }
      let dt = new Date(time)
      this.time1 = getFormatDate('YYYY-mm-dd', dt)
      this.time2 = getFormatDate('HH:MM:SS', dt)
      this.$store.commit('setSystemTime', this.time1+" "+this.time2);
      this.getWeek()
    },
    syncTime() {
      getSystemTime().then((res) => {
        let response = res.data
        let timestamp = ''
        if (response.code == 200) {
          let t = response.data
          timestamp = parseInt(t.timestamp)
          let time = t.time
          this.showAndSetTime(time)
        } else {
          timestamp = window.time || new Date().getTime()
        }
        sessionStorage.setItem('sysTime',timestamp+'')
      })
    },
  },
  created() {

  },
  watch: {
    '$store.state.app.local':{
      deep: true,
      immediate: true,
      handler(val,nval) {
        if(val == 'en-US'){
          $('.showMore ul').css('min-width','2rem');
        }else{
          $('.showMore ul').css('min-width','1.625rem');
        }
      }
    },
    '$store.state.clickData.hiddenMenuId': {
      handler(val) {
        if (val) {
          $('.activeInHidden').parents('ivu-dropdown-item').addClass('selectedActive')
        }

      },
      deep: true,
      immediate: true
    },
    '$store.state.cacheData.windowClear':{
      handler(val) {
        if (val) {
          if (this.monitorOpen !== '') {
            if (this.monitorOpen.name !== '') {
              this.monitorOpen.close()
            }
          }
          if (this.electronicMap !== '') {
            if (this.electronicMap.name !== '') {
              this.electronicMap.close()
            }
          }
          this.$store.commit('setWindowClear', fasle);
        }

      },
    },
    '$store.state.cacheData.isShowChild':{
      handler(val) {
        if(this.$store.state.cacheData.cascadeFirst){
          return;
        }
        this.configValue.isShowChild = val;
        this.setConfigValue("1");
      },
    },
    '$store.state.cacheData.timerNumber':{
      handler(val) {
        if (val) {
          if(this.$store.state.cacheData.cascadeFirst){
            return;
          }
          this.configValue.timerNumber = val;
          this.setConfigValue("1");
        }
      },
    },
    '$store.state.user.lic':{
      deep:true,
      immediate:true,
      handler(lic){
        //let lic = this.$store.state.user.lic
        if (lic) {
          let arr = lic.split(';')
          for (let i = 0; i < arr.length; i++) {
            let have = arr[i]
            if (have === 'yes') {
              this.menuArr[i] = true
            } else if (have === 'no') {
              this.menuArr[i] = false
            }
            if (have === 'gis') {
              this.menuArr[i] = true
            }
          }
          //增加视频会议权限
          if (this.$store.state.user.videoConf > 0) {
            this.menuArr[7] = true
            this.$store.commit('setHaveVoiceConf',true)
          }
          if (arr.length < 9) {
            this.menuArr[8] = true
          }
          this.getUserConfig()
        }
      }
    },
    serverTime:{
      immediate:true,
      deep:true,
      handler(value) {
        this.showAndSetTime(value)
      }
    }
  },
  computed: {
    channelCount:function(){
      let count = this.$store.state.chatChannel.channelTotalUnread;
      return count ? (count > 99 ? 100 : count) : 0
    },
    //判断上报信息是否在更多中 0代表都不存在，1代表上报信息 2代表视频监视 3代表都在。
    //更新：由于要素过多，改为实时计算。
    isShowBadge: function () {
      let flag = 0;
      let temp = this.hiddenMenuItem.find(item => item.type == "reporting_information")
      flag = temp!=undefined ? this.messageCount + flag : flag
      temp = this.hiddenMenuItem.find(item => item.type == "video_surveillance")
      flag = temp!=undefined ? this.videoCount + flag : flag;
      temp = this.hiddenMenuItem.find(item => item.type == "chatChannel")
      flag = temp!=undefined ? this.channelCount + flag : flag;
      return flag;
    },
    sysHeight: function () {
      return this.$store.state.app.sysHeight
    },
    sysWidth: function () {
      return this.$store.state.app.sysWidth
    },
    showSys() {
      let roles = this.$store.state.user.roleModule
      if (roles && roles.length > 0) {
        return true
      } else {
        return false
      }
    },
    local() {
      return this.$store.state.app.local
    },
    userAvatar() {
      let _userImg = this.$store.state.user.avatarImgPath
      if (!_userImg) {
        _userImg = userImg
      }
      return _userImg
    },
    logoPath() {
      let path = this.$store.state.app.logoPath
      if (!path) {
        let lang = this.$i18n.locale
        //path = logo
        //path = this.$config.logo.zh
        switch (lang) {
          case 'zh-CN':
            path = this.logoCN
            break
          case 'zh-TW':
            path = this.logoTW
            break
          case 'en-US':
            path = this.logoEN
            break
          default:
            path = this.logoCN
            break
        }
      } else {
        path = this.$config.baseUrl.pro + path
      }
      return path+"?v="+Math.random();
    },
    isActive: {
      get() {
        if (this.$store.state.clickData.menuId === '') {
          return localRead('currentMenu')
        } else {
          return this.$store.state.clickData.menuId
        }
      },
      set(val) {
        localSave('currentMenu', val)
        return val
      }
    },
    isActiveInHidden: {
      get() {
        if (this.$store.state.clickData.hiddenMenuId === '') {
          return localRead('currentMenuInHidden')
        } else {
          return this.$store.state.clickData.hiddenMenuId
        }
      },
      set(val) {
        localSave('currentMenuInHidden', val)
        return val
      }
    },
    isActiveInHiddenItem() {
      return function (menuInHidden) {
        let tempMenuInHidden = this.$store.state.clickData.hiddenMenuId === '' ? localRead('currentMenuInHidden') : this.$store.state.clickData.hiddenMenuId
        if (tempMenuInHidden === menuInHidden) {
          return true
        } else {
          return false
        }
      }
    },
    isConnected() {
      let isConnected = false
      let socket = this.$store.state.websocket.WS
      if (socket) {
        if (socket._alive) {
          if (this.$store.state.cacheData.inline) {
            isConnected = true
          }
        }
      }
      if (isConnected) {
        if (this.syncTimer) {
          clearInterval(this.syncTimer)
          this.syncTimer = null
        }
      } else {
        this.syncTime()
        if (this.syncTimer) {
          clearInterval(this.syncTimer)
          this.syncTimer = setInterval(()=>{
            this.syncTime()
          },60000)
        }
      }
      return isConnected
    },
  },
  mounted() {
    // this.setLocal(this.$i18n.locale)
    if(this.$store.state.app.local == 'en-US'){
      $('.showMore ul').css('min-width','2rem');
    }else{
      $('.showMore ul').css('min-width','1.625rem');
    }

    this.$root.bus.$on('updateConfig',()=>{
      this.setConfigValue()
    })
    this.$root.bus.$on('startBroad', id => {
      if (id == this.emergencyBroad.id) {
        this.queryEmBroad()
      }
    })
    this.$root.bus.$on('stopBroad', id => {
      if (id == this.emergencyBroad.id) {
        this.queryEmBroad()
      }
    })

    window.addEventListener('resize',this.setHeight)
    this.$once('hook:beforeDestroy',()=>{
      window.removeEventListener('resize',this.setHeight)
      this.$root.bus.$off('updateConfig')
      this.$root.bus.$off('startBroad')
      this.$root.bus.$off('stopBroad')
    })

    if (this.interval) {
      clearInterval(this.interval)
      this.interval=null
    }
    this.interval = setInterval(() => {
      let dtime = sessionStorage.getItem('sysTime')
      if (!dtime) {
        dtime = window.time || new Date().getTime()
      }
      let timestamp = parseInt(dtime)
      timestamp += 1000
      window.time = timestamp
      sessionStorage.setItem('sysTime', timestamp + '')
      //从store获取时间
      let time = this.$store.state.cacheData.systemTime
      if (time) {
        let ts = new Date(time).getTime() + 1000
        let dt = getFormatDate('YYYY-mm-dd HH:MM:SS', new Date(ts))
        this.showAndSetTime(dt)
      } else {
        this.syncTime()
      }
    }, 1000)

    this.$nextTick(async ()=>{
      await this.queryEmBroad()
    })
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/components/header-bar/header-bar.vue